import { Components, Theme } from '@mui/joy';

export const JoyAutocompleteConfig: Partial<Components<Theme>> = {
  JoyAutocomplete: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        return {
          ...(!ownerState.error && {
            borderColor: theme.palette.neutral[300],
          }),
          backgroundColor: theme.palette.common.white,
          boxShadow: 'none',
          borderRadius: '4px',
          minHeight: '40px',
          color: theme.palette.neutral.outlinedColor,
          '&:hover': {
            borderColor: ownerState.error ? theme.palette.danger[500] : theme.palette.primary[500],
          },
          '&.is-invalid': {
            borderColor: 'var(--joy-palette-danger-500)',
          },
        };
      },
    },
  },
  JoyAutocompleteOption: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          '--Icon-color': 'currentColor',
          '--ListItemDecorator-size': '1.5rem',
          '&[aria-disabled="true"]': {
            pointerEvents: 'none',
            cursor: 'default',
            color: theme.palette.neutral.plainDisabledColor,
          },
        };
      },
    },
  },
};
